import { render, staticRenderFns } from "./paid.vue?vue&type=template&id=2763b7de&"
import script from "./paid.vue?vue&type=script&lang=js&"
export * from "./paid.vue?vue&type=script&lang=js&"
import style0 from "./paid.vue?vue&type=style&index=0&id=2763b7de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports